<div class="divider">
  <div class="label">
    <ng-content></ng-content>
  </div>
</div>
